export const RoleName = {
  VIEWER: 'Viewer',
  ADMIN: 'Admin',
  EDITOR: 'Editor',
  PUBLISHER: 'Publisher',
  TECH_SUPPORT: 'TechSupport',

  EXPERIMENT_COUNCIL: 'ExperimentCouncil',
  EXPERIMENT_MODERATOR: 'ExperimentModerator',
  ROLLOUT_MODERATOR: 'RolloutModerator',
  MODERATOR: 'Moderator',
};
